var React = require('react');

function MapPinNumbered (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.209 0C11.24 0 5.83398 4.96271 5.83398 11.0863C5.83398 17.2083 10.7665 24.5175 17.209 35C23.6515 24.5175 28.584 17.2083 28.584 11.0863C28.584 4.96271 23.1794 0 17.209 0Z","fill":"#872175"}));
}

MapPinNumbered.defaultProps = {"height":"35","viewBox":"0 0 35 35","fill":"none"};

module.exports = MapPinNumbered;

MapPinNumbered.default = MapPinNumbered;
